// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @vowkey/platform/no-enums
export enum StorageLocationEnum {
  Both = "both",
  Disk = "disk",
  Memory = "memory",
}
